import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/* hs-eslint ignored failing-rules */

/* eslint-disable hubspot-dev/no-default-react-imports */
import ProductInfoContainer from '../../common/ProductInfoContainer';
import ProductPageTitle, { ProductPageHeader } from '../../product-pages/ProductPageTitle';
import { NavMarker } from 'react-rhumb';
import ProductPageSubtitle from '../../product-pages/ProductPageSubtitle';
import MobileDropdownNav from '../MobileDropdownNav';
import CompareStatusFooter from '../../compare/CompareStatusFooter';
import { useSelector } from 'react-redux';
import FailedLoadBanner from '../../common/loading/FailedLoadBanner';
import BannerSection from '../../banners/BannerSection';
import { ProductPageContext } from '../../../context/ProductPageContext';
import { hasPricingAndPurchasingFailedSelector } from '../../../selectors/LoadingStateSelectors';
import FallbackErrorBanner from '../../common/loading/FallbackErrorBanner';
import MobileCurrencyPicker from '../MobileCurrencyPicker';
import SegmentedTabs from '../../layout/tabs/SegmentedTabs';
import { FaqsConfig } from '../../../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../../../constants/routing/NavItems';
import CustomerSupport from '../../common/CustomerSupport';
import CodeSplitEnvWrapper from '../../common/env/CodeSplitEnvWrapper';
import IntegrationsSection from '../../common/Integrations';
import Faq from '../../faqs/Faq';
import FooterMicrocopy from '../../faqs/FooterMicrocopy';
import Question from '../../faqs/Question';
import PhoneSupportFooter from '../../common/PhoneSupportFooter';

const MobileWrapperWithTabs = ({
  navMarkerName,
  navItem,
  children,
  productLine,
  highlightedProductsValue,
  screen,
  tab,
  setTab
}) => {
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-selenium-id": "page-success",
      children: [/*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerName
      }), /*#__PURE__*/_jsx(SegmentedTabs, {
        selectedTab: tab,
        bordered: true,
        use: "enclosed",
        path: `/${productLine}`,
        setTab: setTab
      }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
        selectedNavItem: navItem
      }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
        children: [/*#__PURE__*/_jsxs(ProductPageContext.Provider, {
          value: {
            highlightedProducts: highlightedProductsValue
          },
          children: [/*#__PURE__*/_jsx(BannerSection, {
            productLine: productLine,
            screen: screen
          }), /*#__PURE__*/_jsx(FailedLoadBanner, {
            hasFailed: hasPricingAndPurchasingFailed
          }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(ProductPageHeader, {
            children: [/*#__PURE__*/_jsx(ProductPageTitle, {
              productLine: productLine
            }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
              productLine: productLine
            })]
          }), children]
        }), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
          publicComponentLoader: () => import(
          /* webpackChunkName: "public-chunk" */
          `pricing-pages-ui/components/company-proof/CompanyProof`),
          publicComponentProps: {
            tab
          }
        }), /*#__PURE__*/_jsx(CustomerSupport, {}), /*#__PURE__*/_jsxs(Faq, {
          children: [FaqsConfig[navItem].map((_ref) => {
            let {
              questionKey
            } = _ref,
                passthroughOptions = _objectWithoutPropertiesLoose(_ref, ["questionKey"]);

            return /*#__PURE__*/_jsx(Question, Object.assign({
              questionKey: questionKey
            }, passthroughOptions), questionKey);
          }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
        }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
          phoneSourceId: `${NavItemEnum[productLine]}-footer`,
          screen: screen
        })]
      }), /*#__PURE__*/_jsx(CompareStatusFooter, {})]
    })
  });
};

export default MobileWrapperWithTabs;